import styled from '@emotion/styled'

import { spacingSection } from '@/styles/mixins'
import { mediaUp } from '@/styles/media'
import Title from '@/components/common/Title'

export const Container = styled.section`
  ${spacingSection};
`

export const TitleContainer = styled(Title)`
  ${mediaUp('md')} {
    br {
      display: none;
    }
  }
`
